import React, { useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import { User, Post } from '../../types';

const UserProfile: React.FC = () => {
  const { id } = useParams<{ id: string }>();
  const [activeTab, setActiveTab] = useState<'posts' | 'about'>('posts');

  // 模拟用户数据
  const mockUser: User = {
    id: '1',
    uuid: 'user-1',
    name: '李华',
    email: 'lihua@example.com',
    avatar: 'https://i.pravatar.cc/150?img=10',
    bio: '前端开发工程师 | React专家 | 热爱技术分享',
    createdAt: '2023-01-01',
    updatedAt: '2023-01-01'
  };

  // 模拟文章数据
  const mockPosts: Post[] = [
    {
      id: '1',
      title: 'React Hooks 最佳实践',
      content: '本文将分享一些使用 React Hooks 的最佳实践和常见陷阱...',
      author: mockUser,
      category: 'article',
      tags: ['React', 'Hooks', '前端'],
      createdAt: '2023-01-01',
      updatedAt: '2023-01-01'
    },
    // 添加更多模拟文章...
  ];

  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
      {/* 用户信息卡片 */}
      <div className="bg-white shadow rounded-lg overflow-hidden">
        <div className="px-4 py-5 sm:px-6">
          <div className="flex items-center">
            <div className="flex-shrink-0">
              <img
                className="h-24 w-24 rounded-full"
                src={mockUser.avatar}
                alt={mockUser.name}
              />
            </div>
            <div className="ml-6">
              <h3 className="text-2xl font-bold text-gray-900">{mockUser.name}</h3>
              <p className="text-sm text-gray-500">{mockUser.bio}</p>
              <div className="mt-4 flex space-x-4">
                <button className="inline-flex items-center px-4 py-2 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-primary-600 hover:bg-primary-700">
                  关注
                </button>
                <button className="inline-flex items-center px-4 py-2 border border-gray-300 rounded-md shadow-sm text-sm font-medium text-gray-700 bg-white hover:bg-gray-50">
                  发送消息
                </button>
              </div>
            </div>
          </div>
        </div>

        {/* 标签页 */}
        <div className="border-t border-gray-200">
          <nav className="flex">
            <button
              onClick={() => setActiveTab('posts')}
              className={`${
                activeTab === 'posts'
                  ? 'border-primary-500 text-primary-600'
                  : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
              } px-4 py-4 text-sm font-medium border-b-2`}
            >
              文章
            </button>
            <button
              onClick={() => setActiveTab('about')}
              className={`${
                activeTab === 'about'
                  ? 'border-primary-500 text-primary-600'
                  : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
              } px-4 py-4 text-sm font-medium border-b-2`}
            >
              关于
            </button>
          </nav>
        </div>

        {/* 内容区域 */}
        <div className="px-4 py-5 sm:p-6">
          {activeTab === 'posts' ? (
            <div className="space-y-6">
              {mockPosts.map((post) => (
                <div key={post.id} className="border-b border-gray-200 pb-6">
                  <div className="flex items-center justify-between">
                    <span className="inline-flex items-center px-3 py-0.5 rounded-full text-sm font-medium bg-primary-100 text-primary-800">
                      {post.category === 'article' ? '文章' : post.category === 'job' ? '职位' : '专栏'}
                    </span>
                    <span className="text-sm text-gray-500">
                      {new Date(post.createdAt).toLocaleDateString()}
                    </span>
                  </div>
                  <h3 className="mt-2 text-lg font-medium text-gray-900">
                    <Link to={`/community/posts/${post.id}`}>{post.title}</Link>
                  </h3>
                  <p className="mt-2 text-sm text-gray-500">{post.content}</p>
                  <div className="mt-4 flex flex-wrap gap-2">
                    {post.tags.map((tag) => (
                      <span
                        key={tag}
                        className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-gray-100 text-gray-800"
                      >
                        {tag}
                      </span>
                    ))}
                  </div>
                </div>
              ))}
            </div>
          ) : (
            <div className="prose max-w-none">
              <h3 className="text-lg font-medium text-gray-900">个人简介</h3>
              <p className="mt-2 text-gray-500">
                {mockUser.bio}
              </p>
              <h3 className="mt-6 text-lg font-medium text-gray-900">联系方式</h3>
              <p className="mt-2 text-gray-500">
                邮箱：{mockUser.email}
              </p>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default UserProfile; 